export default {
    iconName: {
        type: String,
        default: 'box'
    },
    width: {
        type: [Number, String],
        default: 20
    },
    height: {
        type: [Number, String],
        default: 20
    },
    viewBox: {
        type: String,
        default: "0 0 20 20",
    },
    color: {
        type: String,
        default: 'none'
    }
};

